import { render, staticRenderFns } from "./DoctorConfigView.vue?vue&type=template&id=7df221e2&scoped=true&"
import script from "./DoctorConfigView.vue?vue&type=script&lang=js&"
export * from "./DoctorConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df221e2",
  null
  
)

export default component.exports